import React from 'react';

const InputWithPrefix = ({
	prefix = '$', // Default prefix is '$'
	children,
	style = {},
	inputStyle = {},
	...props
}) => {
	return (
		<div style={{ position: 'relative', width: '100%', ...style }}>
			{/* Prefix */}
			<span
				style={{
					position: 'absolute',
					left: '10px', // Adjust based on design
					top: '50%',
					transform: 'translateY(-50%)',
					color: '#555',
					pointerEvents: 'none', // Prevent interaction
					fontSize: '14px' // Match input font size
				}}
			>
				{prefix}
			</span>
			{/* Input */}
			{React.cloneElement(children, {
				style: {
					paddingLeft: '25px', // Create space for prefix
					width: '100%',
					boxSizing: 'border-box',
					...inputStyle, // Allow input-specific styles
					...children.props.style // Preserve original styles
				},
				...props
			})}
		</div>
	);
};

export default InputWithPrefix;
